module.exports = __webpack_public_path__ + "efb453e0643ab818a6bff96d52c56942.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-18.png
// module id = 2595
// module chunks = 0